/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import parse from 'html-react-parser'
import settings from "../helpers/settings"
import { Script } from "gatsby"
import { singleProductUsersCount } from "../helpers/singleProductUsersCount"
import generateHomePageSchema from "../helpers/homePageSchema"

const Seo = ({ 
  seo, 
  // faq, 
  // faqData, 
  singleProduct, 
  singleProductData, 
  featuredImage, 
  authorAvatar, 
  isAuthorPage,
  authorUrl,
  isRoundUp,
  author,
  authorName,
  uri,
  isNewCategory,
  isHomePage
}) => {

  const siteUrl = process.env.GATSBY_SITE_URL.slice( 0, -1 )

  const wpSiteUrl = settings[ process.env.GATSBY_SITE_LANG ].wpSiteUrl

  const siteLang = settings[ process.env.GATSBY_SITE_LANG ].lang

  /**
   * FAQ achema
   */
  // let faqSchema = {}

  // let tmp = []

  // faqData?.forEach(item => {
  //   tmp.push({
  //     "@type": "Question",
  //     "name": item.faqTitle,
  //     "acceptedAnswer": {
  //       "@type": "Answer",
  //       "text": item.faqContent
  //     }
  //   })
  // })

  // faqSchema = {
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": tmp
  // }

  /** === END FAQ Schema === */
  
  /**
   * Single Product Schema
   */

  let singleProductSchema = {}

  const fImage = featuredImage?.images?.fallback?.src !== undefined ? siteUrl + featuredImage.images.fallback.src : singleProductData?.featuredImage?.node?.gatsbyImage?.images?.fallback?.src

  if ( singleProduct ) {

    const usersRating = singleProductUsersCount( singleProductData )

    const overallRating = usersRating.rating !== 0 ? ( singleProductData?.singleProductReview?.ratingProSingle + usersRating.rating ) / 2 : singleProductData?.singleProductReview?.ratingProSingle

    singleProductSchema = {
      "@context": "https://schema.org",
      "@graph": {
        "@type": "Product",
        "name": singleProductData?.singleProductReview?.dynamicLabel1,
        "description": singleProductData?.singleProductReview?.productDescription,
        "image": {
          "@type": "ImageObject",
          "url": featuredImage
        },
        "brand": {
          "@type": "Brand",
          "name": singleProductData?.singleProductReview?.brand
        },
        "aggregateRating" : {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": overallRating.toFixed( 2 ),
          "ratingCount": usersRating.reviewsCount
        },
        "review": {
          "@type": "Review",
          "datePublished": singleProductData?.date,
          "dateModified": singleProductData?.modified,
          "author": {
            "@type": "Person",
            "name": singleProductData?.author?.node?.name,
            "url": siteUrl + singleProductData?.author?.node?.uri
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": singleProductData?.singleProductReview?.ratingProSingle,
            "worstRating": "1",
            "bestRating": "5"
          },
          "headline": seo?.title,
          "image": {
            "@type": "ImageObject",
            "url": fImage
          },
          "url": `${siteUrl}/${singleProductData?.slug}/`
        }
      }
    }
  }
    

  /** === END Single Product Schema === */

  let fullHead = seo?.fullHead?.replaceAll( wpSiteUrl, siteUrl )

  if( fullHead ){
    
    const fh = fullHead?.split('<meta property="og:image" content="')

    const h1 = fh[0]
  
    let h2 = fh[1]?.split('"')
    
    const currentImage = h2?.shift()

    if ( currentImage?.includes( siteUrl ) ) {
      const replacedImage = currentImage.replace( siteUrl, wpSiteUrl )
      fullHead = fullHead?.replaceAll(`<meta property="og:image" content="${currentImage}`, `<meta property="og:image" content="${replacedImage}`)
    }
  
    // if(featuredImage?.childImageSharp?.gatsbyImageData?.images?.fallback?.src){
    //   fullHead = fullHead?.replaceAll(`<meta property="og:image" content="${currentImage}`, `<meta property="og:image" content="${siteUrl}${featuredImage.childImageSharp.gatsbyImageData.images.fallback.src}`)
    // } 

    // if( isAuthorPage !== undefined && isAuthorPage === true ) {
      
    //   if( authorAvatar !== undefined && authorAvatar !== null ) {
    //     fullHead = fullHead?.replaceAll(`<meta property="og:image" content="${currentImage}`, `<meta property="og:image" content="${siteUrl}${authorAvatar.images.fallback.src}`)
    //   }
  
    // }
  }
  
  /**
   * Canonical
   */

  let canonical = seo?.opengraphUrl ? `${siteUrl}${seo.opengraphUrl}` : null

  /**
   * TO DO: Check why does 'seo.opengraphUrl' sometimes is uqual to '/graphql/'
   */


  if ( seo?.opengraphUrl === '/graphql/') {
    if ( 'undefined' !== uri ) {
      canonical = `${siteUrl}${uri}`
    }
    // typeof window !== "undefined" && ( canonical = `${siteUrl}${window.location.pathname}` )
  }
  
  /** === END Canonical === */

  /**
   * SEO Schema
   */

  let seoSchema = {}

  let schema = seo?.schema !== undefined ? JSON?.parse( seo?.schema?.raw ) : null
  
  let contextArray = []

  if( schema ){

    schema['@graph'].forEach( item => {

      if ( item['@type'] === 'WebSite' ) {
        
        contextArray.push({...item, url : siteUrl })
        return

      }
    
      if(item['@type'] === 'Organization'){
        let logo = item.logo
        logo = {...logo, contentUrl : fImage, url : fImage}
        contextArray.push({...item, logo : logo, url : siteUrl})       
        return
      } 

      if(item['@type'] === 'ImageObject') {
        contextArray.push({...item, url : fImage, contentUrl : fImage})       
        return
      } 
      
      if(item['@type'] === 'BreadcrumbList'){

        let brEls = item.itemListElement

        let newEls = []

        brEls.forEach(el => {

          if(el.item){
            newEls.push({...el, item : `${siteUrl}${el.item}`})
          } else {
            newEls.push(el)
          }

        })
        contextArray.push({...item, itemListElement : newEls})       
        return
      } 

      if(item['@type'] === 'Article'){
        let authorSchema = item.author

        authorSchema = {...authorSchema, url : siteUrl + author?.node?.uri}
        
        contextArray.push({...item, thumbnailUrl : fImage, author : authorSchema}) 
        return
      }

      if(item['@type'] === 'WebPage'){
        contextArray.push({...item, thumbnailUrl : fImage, url : siteUrl + item.url}) 
        return
      }

      if( item['@type'] === 'Person' ) {

        let person = item
        
        if( authorAvatar !== undefined && authorAvatar !== null ) {

          const avatarUrl = siteUrl + authorAvatar.images.fallback.src

          let image = item.image

          image = {...image, url : avatarUrl, contentUrl : avatarUrl }

          person = {...person, image : image}
          
        } 

        if ( isAuthorPage ) {

          person = {...person, url : siteUrl + authorUrl}

        }

        if ( singleProduct || isRoundUp ) {

          person = {...person, url : siteUrl + item.url}

        }

        contextArray.push( person )
    
        return
        
      }

      contextArray.push( item )

    })

    seoSchema = { ['@context'] : schema['@context'], ['@graph'] : contextArray }

  }  

  
  return (
    <>
    <Script src="https://offer-go.com/wct.js" strategy="post-hydrate"/>
    <Script type="text/javascript" strategy="post-hydrate">
      {`
      (function(w, c, t, u) {
        var len = document.querySelector('script[src="https://wct-2.com/wct.js"]');
        if ( len !== null ) {
          document.querySelector('script[src="https://wct-2.com/wct.js"]').remove();
        }
        w._wct = w._wct || {}; w._wct = u;
        var s = c.createElement(t);
        s.type = 'text/javascript'; s.async = true; s.src = 'https://wct-2.com/wct.js';
        var r = c.getElementsByTagName(t)[0];
        r.parentNode.insertBefore(s, r);
      }(window, document, 'script', {
          'uid' : 'ppIyEx',
          'proxy' : 'https://wct-2.com',
          'auto_tagging' : true,
          'alterAffiliateAnchorTag' : function (anchor) {
              anchor.setAttribute('rel', 'sponsored');
              anchor.setAttribute('target', '_blank');
          }
      }));
      `}  
    </Script>

    <Helmet htmlAttributes={{ lang: siteLang }}>

      {/** Display Home Page schema */
      isHomePage &&
      <script type="application/ld+json">
        {/* {seo.schema.raw && parse( seo.schema.raw )} */}
        {JSON.stringify( generateHomePageSchema( seo ) )}
      </script>
      /** End of Home Page schema */}
  
      {'en' === process.env.GATSBY_SITE_LANG &&
      <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NKZFV8ZT');`}
      </script>}

      {'de' === process.env.GATSBY_SITE_LANG &&
      <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MFZ5CVJ5');`}
      </script>}

      {isAuthorPage && <title>{authorName}</title>}

      {/** For pages where SEO title and description ar set manually */}
      { isNewCategory && seo?.title && <title>{seo.title}</title> }
      { isNewCategory && seo?.description && <meta name="description" content={seo.description} /> }

      {canonical !== null && <link rel="canonical" href={canonical} />}
      { fullHead && parse( fullHead.replaceAll( '/graphql', siteUrl ) ) }
      
      { ! isHomePage &&
      <script type="application/ld+json" class="yoast-schema-graph">
        {JSON.stringify( seoSchema ).replaceAll( '/graphql', siteUrl )}
      </script>}

      {/* {faq &&
      <script type="application/ld+json">
        {JSON.stringify( faqSchema )}
      </script>
      } */}

      {singleProduct && 
      <script type="application/ld+json">
        {JSON.stringify( singleProductSchema )}
      </script>}

      <meta name="apple-mobile-web-app-status-bar-style" content="#FF4D54" />
    </Helmet>
    </>
  )
}

Seo.defaultProps = {
  lang: process.env.GATSBY_SITE_LANG,
  // meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  // meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
